export const DASHBOARD_GET_PENDING_ARTICLES = 'DASHBOARD_GET_PENDING_ARTICLES';
export const DASHBOARD_GET_PENDING_ARTICLES_SUCCESS = 'DASHBOARD_GET_PENDING_ARTICLES_SUCCESS';
export const DASHBOARD_GET_PENDING_ARTICLES_FAILURE = 'DASHBOARD_GET_PENDING_ARTICLES_FAILURE';

export const DASHBOARD_GET_SCHEDULED_ARTICLES = 'DASHBOARD_GET_SCHEDULED_ARTICLES';
export const DASHBOARD_GET_SCHEDULED_ARTICLES_SUCCESS = 'DASHBOARD_GET_SCHEDULED_ARTICLES_SUCCESS';
export const DASHBOARD_GET_SCHEDULED_ARTICLES_FAILURE = 'DASHBOARD_GET_SCHEDULED_ARTICLES_FAILURE';

export const DASHBOARD_PROPS_CHANGED = 'DASHBOARD_PROPS_CHANGED';